import React, { useEffect, useState, useRef } from "react";
import api from "../../utils/api";
import APIConstant from "../../utils/constant";
import Loader from "components/Shared/Loader/Loader";
import SimpleBackdrop from "utils/general";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { OverlayPanel } from "primereact/overlaypanel";
import _ from "lodash";
import { Dropdown } from "primereact/dropdown";
import { SelectButton } from "primereact/selectbutton";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import DataTableWithoutPagination from "components/DyanmicDataList/DataTableWithoutPagination";
import * as ExcelJS from "exceljs";
import FileSaver from "file-saver";
import moment from "moment";

const groupByList = [
  {
    label: "None",
    value: "None",
  },
  {
    label: "Items",
    value: "Items",
  },
  {
    label: "Godown",
    value: "Godown",
  },
];
const filterOptions = ["Today", "7 Days", "30 Days"];

const MachineryConsumptionReport = (props) => {
  const initialFilterState = {
    FilterDate: "",
    FromDate: [new Date(), new Date()],
    Machine: [],
    Item: [],
    Subwarehouse: [],
    GroupBy: "None",
  };
  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const [machineryReportList, setMachineryReportList] = useState([]);
  const [userId, setUserId] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [
    filteredMachineryReportList,
    setFilteredMachineryReportList,
  ] = useState([]);
  // const [value, setValue] = useState(filterOptions[0]);
  const [itemList, setItemList] = useState([]);
  const [subwarehouseList, setSubWareHouseList] = useState([]);
  const [equipmentList, setEquipmentList] = useState([]);
  const [filterData, setFilterData] = useState(initialFilterState);
  const [showCalendar, setShowCalendar] = useState(false);
  const [tempFromDate, setTempFromDate] = useState(initialFilterState.FromDate);

  const [userPageAccess, setUserPageAccess] = useState([]);
  const [expandedRows, setExpandedRows] = useState(false);

  const [summaryData, setSummaryData] = useState({
    Details: {},
    Columns: [],
    Data: [],
  });
  const [showSummary, setShowSummary] = useState(false);

  const op = useRef(null);
  const excelMenuOp = useRef(null);

  useEffect(() => {
    if (op.current) {
      const patcher = (methodName) => {
        const originalMethod = op.current[methodName];
        if (originalMethod) {
          op.current[methodName] = (event) => {
            // Check if the click target is no longer in the DOM.
            // This happens with the calendar month/year navigation arrows,
            // which are removed on click, causing a false "outside" click detection.
            if (event.target && !document.body.contains(event.target)) {
              return false; // This was an inside click on a removed element.
            }
            // Proceed with the original logic.
            return originalMethod.call(op.current, event);
          };
        }
      };
      patcher("isOutsideClicked");
      patcher("hasOutsideClicked");
    }
  }, []);

  useEffect(() => {
    let token = localStorage.getItem("Token");
    let data = localStorage.getItem("Infodata");
    let Userrole = JSON.parse(localStorage.getItem("Userdata"));
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);
    getItemList(data);
    GetSubWareHouseList(data);
    GetEquipmentMaster(data);
    GetMachineryReport(data);
  }, []);

  useEffect(() => {
    if (!filterData.FilterDate) return;

    const today = moment();
    let range = null;

    switch (filterData.FilterDate) {
      case "Today":
        range = [today.startOf("day").toDate(), today.endOf("day").toDate()];
        break;
      case "7 Days":
        range = [
          moment()
            .subtract(6, "days")
            .startOf("day")
            .toDate(),
          today.endOf("day").toDate(),
        ];
        break;
      case "30 Days":
        range = [
          moment()
            .subtract(29, "days")
            .startOf("day")
            .toDate(),
          today.endOf("day").toDate(),
        ];
        break;
      default:
        range = null;
    }

    if (range) {
      setFilterData((prevState) => ({
        ...prevState,
        FromDate: range,
      }));
    }
  }, [filterData.FilterDate]);

  const getItemList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetItemMasterList, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter(
            (x) => x.UserId !== "Admin",
          ).map((item) => ({
            label: item.label,
            value: item.value,
          }));
          setItemList(filterArry);
        }
      })
      .catch((err) => { });
  };

  const GetEquipmentMaster = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetEquipmentMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.map((equipment) => ({
            label: equipment.EquipmentName,
            value: equipment.EquipmentId || equipment._id,
            SerialNo: equipment.SerialNo,
          }));
          setEquipmentList(filterArry);
        }
      })
      .catch((err) => { });
  };

  const GetSubWareHouseList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetSubWareHouseList, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.map((subWareHouse) => ({
            label: subWareHouse.Name,
            value: subWareHouse._id,
          }));
          setSubWareHouseList(filterArry);
        }
      })
      .catch((err) => { });
  };

  const GetMachineryReport = async (UserId, filter) => {
    let tempFilter = filter || filterData;
    Loader.show();
    if (validate()) {
      try {
        let params = {
          UserId: UserId,
          Filters: tempFilter,
        };
        await api
          .post(APIConstant.path.GetMachineryReport, params)
          .then(async (res) => {
            if (res.Success === 1) {
              Loader.hide();
              setMachineryReportList(res.Data);
              setFilteredMachineryReportList(res.Data);
              op.current.hide();
            } else {
              Loader.hide();
              setMachineryReportList([]);
              setFilteredMachineryReportList([]);
              op.current.hide();
            }
          })
          .catch((err) => {
            console.log(err);
            Loader.hide();
          });
      } catch (err) {
        console.error(err);
        Loader.hide();
      }
    } else {
      Loader.hide();
    }
  };

  const validate = () => {
    let isValid = true;

    return isValid;
  };

  const handleReset = (e) => {
    op.current.hide();
    GetMachineryReport(userId, initialFilterState);
  };

  const handleGlobalFilter = (e) => {
    const value = e.target.value;
    setGlobalFilter(value);

    if (!machineryReportList || typeof machineryReportList !== "object") {
      return;
    }

    if (!value || !value.trim()) {
      setFilteredMachineryReportList(machineryReportList);
      return;
    }

    const lower = value.toLowerCase();
    const filtered = {};

    Object.entries(machineryReportList).forEach(([groupName, items]) => {
      const isGroupMatch = groupName.toLowerCase().includes(lower);

      const matchingItems = (items || []).filter((item) => {
        return (
          (item.Item && item.Item.toLowerCase().includes(lower)) ||
          (item.Machine && item.Machine.toLowerCase().includes(lower)) ||
          (item.EquipmentName &&
            item.EquipmentName.toLowerCase().includes(lower)) ||
          (item.OutwardNumber &&
            String(item.OutwardNumber).toLowerCase().includes(lower)) ||
          (item.Invoice &&
            String(item.Invoice).toLowerCase().includes(lower)) ||
          (item.Subwarehouse &&
            item.Subwarehouse.toLowerCase().includes(lower)) ||
          (item.Godown && item.Godown.toLowerCase().includes(lower)) ||
          (item.Date && item.Date.toLowerCase().includes(lower))
        );
      });

      if (isGroupMatch) {
        filtered[groupName] = items;
      } else if (matchingItems.length > 0) {
        filtered[groupName] = matchingItems;
      }
    });

    setFilteredMachineryReportList(filtered);
  };

  const handleClose = () => {
    setShowSummary(false);
    setSummaryData({
      Columns: [],
      Data: [],
    });
  };

  const exportToExcel = async (exportType) => {
    if (
      !filteredMachineryReportList ||
      !Object.keys(filteredMachineryReportList).length
    ) {
      return;
    }

    const type =
      exportType || (filterData.GroupBy === "Items" ? "Item" : "Machine");

    try {
      const workbook = new ExcelJS.Workbook();
      let sheetName = "Machine Wise Report";
      let reportTitle = "Machinery Report (Machine Wise)";
      let reportTypeName = "Machine Wise";
      let fileName = "Machinery_Report_Machine_Wise.xlsx";

      if (type === "MachineSummary") {
        sheetName = "Machine Summary Report";
        reportTitle = "Machinery Report (Machine Wise Summary)";
        reportTypeName = "Machine Wise Summary";
        fileName = "Machinery_Report_Machine_Wise_Summary.xlsx";
      } else if (type === "ItemSummary") {
        sheetName = "Item Summary Report";
        reportTitle = "Machinery Report (Item Wise Summary)";
        reportTypeName = "Item Wise Summary";
        fileName = "Machinery_Report_Item_Wise_Summary.xlsx";
      } else if (type === "Item") {
        sheetName = "Item Wise Report";
        reportTitle = "Machinery Report (Item Wise)";
        reportTypeName = "Item Wise";
        fileName = "Machinery_Report_Item_Wise.xlsx";
      }

      const worksheet = workbook.addWorksheet(sheetName);
      const { dateRangeText } = getDateRange();
      let filterStrings = [`Date: ${dateRangeText}`];

      const getLabels = (selectedValues, masterList) => {
        if (!selectedValues || selectedValues.length === 0) return "All";
        return selectedValues
          .map((val) => {
            const found = masterList.find((item) => item.value === val);
            return found ? found.label : val;
          })
          .join(", ");
      };

      filterStrings.push(
        `Machines: ${getLabels(filterData.Machine, equipmentList)}`,
      );
      filterStrings.push(`Items: ${getLabels(filterData.Item, itemList)}`);
      filterStrings.push(
        `Godown: ${getLabels(filterData.Subwarehouse, subwarehouseList)}`,
      );
      filterStrings.push(`Report Type: ${reportTypeName}`);

      // Flatten all entries across all groups
      const allEntries = Object.values(filteredMachineryReportList).flat();

      let columns = [];
      let groupedData = {};

      if (type === "MachineSummary") {
        columns = [
          { header: "Sr.No", field: "Index" },
          { header: "Item Name", field: "Item" },
          { header: "Quantity", field: "Quantity" },
          { header: "Unit", field: "Unit" },
          { header: "Total Cost", field: "Cost" },
        ];

        allEntries.forEach((entry) => {
          const machineKey =
            entry.Machine || entry.EquipmentName || "Unknown Machine";
          if (!groupedData[machineKey]) groupedData[machineKey] = {};

          const itemKey = `${entry.Item || "Unknown Item"}___${entry.Unit || ""}`;
          if (!groupedData[machineKey][itemKey]) {
            groupedData[machineKey][itemKey] = {
              Item: entry.Item || "Unknown Item",
              Unit: entry.Unit || "",
              Quantity: 0,
              Cost: 0,
            };
          }
          groupedData[machineKey][itemKey].Quantity +=
            parseFloat(entry.Quantity) || 0;
          groupedData[machineKey][itemKey].Cost +=
            parseFloat(entry.Cost) || 0;
        });

        // Convert nested objects into sorted arrays
        Object.keys(groupedData).forEach((mKey) => {
          groupedData[mKey] = Object.values(groupedData[mKey]).sort((a, b) =>
            a.Item.localeCompare(b.Item),
          );
        });
      } else if (type === "ItemSummary") {
        columns = [
          { header: "Sr.No", field: "Index" },
          { header: "Machine Name", field: "Machine" },
          { header: "Quantity", field: "Quantity" },
          { header: "Unit", field: "Unit" },
          { header: "Total Cost", field: "Cost" },
        ];

        allEntries.forEach((entry) => {
          const itemKey = entry.Item || "Unknown Item";
          if (!groupedData[itemKey]) groupedData[itemKey] = {};

          const machineKey = `${entry.Machine || entry.EquipmentName || "Unknown Machine"}___${entry.Unit || ""}`;
          if (!groupedData[itemKey][machineKey]) {
            groupedData[itemKey][machineKey] = {
              Machine: entry.Machine || entry.EquipmentName || "Unknown Machine",
              Unit: entry.Unit || "",
              Quantity: 0,
              Cost: 0,
            };
          }
          groupedData[itemKey][machineKey].Quantity +=
            parseFloat(entry.Quantity) || 0;
          groupedData[itemKey][machineKey].Cost +=
            parseFloat(entry.Cost) || 0;
        });

        // Convert nested objects into sorted arrays
        Object.keys(groupedData).forEach((iKey) => {
          groupedData[iKey] = Object.values(groupedData[iKey]).sort((a, b) =>
            a.Machine.localeCompare(b.Machine),
          );
        });
      } else if (type === "Item") {
        columns = [
          { header: "Sr.No", field: "Index" },
          { header: "Date", field: "Date" },
          { header: "Outward Number", field: "OutwardNumber" },
          { header: "Machine", field: "Machine" },
          { header: "Quantity", field: "Quantity" },
          { header: "Unit", field: "Unit" },
          { header: "Cost", field: "Cost" },
          { header: "Subwarehouse", field: "Subwarehouse" },
        ];

        allEntries.forEach((entry) => {
          const itemKey = entry.Item || "Unknown Item";
          if (!groupedData[itemKey]) groupedData[itemKey] = [];
          groupedData[itemKey].push(entry);
        });
      } else {
        // Machine (detailed)
        columns = [
          { header: "Sr.No", field: "Index" },
          { header: "Date", field: "Date" },
          { header: "Outward Number", field: "OutwardNumber" },
          { header: "Item", field: "Item" },
          { header: "Quantity", field: "Quantity" },
          { header: "Unit", field: "Unit" },
          { header: "Cost", field: "Cost" },
          { header: "Subwarehouse", field: "Subwarehouse" },
        ];

        allEntries.forEach((entry) => {
          const machineKey =
            entry.Machine || entry.EquipmentName || "Unknown Machine";
          if (!groupedData[machineKey]) groupedData[machineKey] = [];
          groupedData[machineKey].push(entry);
        });
      }

      // Set column widths and keys
      worksheet.columns = columns.map((col) => ({
        key: col.field,
        width: col.header.length < 20 ? 20 : col.header.length + 5,
      }));

      // Add metadata rows
      worksheet.addRow(["Report Name", reportTitle]).font = {
        bold: true,
        size: 14,
      };
      worksheet.addRow(["Filter", filterStrings.join(" | ")]).font = {
        bold: true,
      };
      worksheet.addRow([
        "Generated On",
        moment().format("DD-MMM-YYYY HH:mm"),
      ]).font = { bold: true };
      worksheet.addRow([]); // Blank row

      // Add Header Row
      worksheet.addRow(columns.map((col) => col.header)).font = {
        bold: true,
      };

      let grandTotalCost = 0;
      let grandTotalQuantity = 0;

      const isItemBased = type === "Item" || type === "ItemSummary";
      const groupEntries = Object.entries(groupedData);

      if (!isItemBased) {
        groupEntries.sort(([nameA], [nameB]) => {
          const equipA = equipmentList.find((e) => e.label === nameA);
          const equipB = equipmentList.find((e) => e.label === nameB);
          const seqA = equipA ? parseInt(equipA.SerialNo) || 9999 : 9999;
          const seqB = equipB ? parseInt(equipB.SerialNo) || 9999 : 9999;
          return seqA !== seqB ? seqA - seqB : nameA.localeCompare(nameB);
        });
      } else {
        groupEntries.sort(([nameA], [nameB]) => nameA.localeCompare(nameB));
      }

      groupEntries.forEach(([groupName, entries]) => {
        worksheet.addRow([]);
        worksheet.addRow([
          `${isItemBased ? "Item" : "Machine"}: ${groupName}`,
        ]).font = {
          bold: true,
        };

        let groupCost = 0;
        let groupQty = 0;

        entries.forEach((item, index) => {
          const row = {};
          columns.forEach((col) => {
            if (col.field === "Index") {
              row[col.field] = index + 1;
            } else if (col.field === "Cost") {
              const c = parseFloat(item.Cost) || 0;
              row[col.field] = c.toFixed(2);
            } else if (col.field === "Quantity") {
              const q = parseFloat(item.Quantity) || 0;
              row[col.field] = Number.isInteger(q)
                ? q
                : parseFloat(q.toFixed(2));
            } else {
              row[col.field] = item[col.field] ?? "";
            }
          });

          const cost = parseFloat(item.Cost) || 0;
          const qty = parseFloat(item.Quantity) || 0;
          groupCost += cost;
          groupQty += qty;
          grandTotalCost += cost;
          grandTotalQuantity += qty;

          worksheet.addRow(row);
        });

        const groupTotalRow = {};
        columns.forEach((col) => {
          if (col.field === "Quantity")
            groupTotalRow[col.field] = Number.isInteger(groupQty)
              ? groupQty
              : parseFloat(groupQty.toFixed(2));
          else if (col.field === "Cost")
            groupTotalRow[col.field] = groupCost.toFixed(2);
          else if (col.field === "Index")
            groupTotalRow[col.field] = "Subtotal";
          else groupTotalRow[col.field] = "";
        });

        worksheet.addRow(groupTotalRow).font = { bold: true };
      });

      // Add Grand Total row
      worksheet.addRow([]);
      const grandTotalRow = {};
      columns.forEach((col) => {
        if (col.field === "Quantity")
          grandTotalRow[col.field] = Number.isInteger(grandTotalQuantity)
            ? grandTotalQuantity
            : parseFloat(grandTotalQuantity.toFixed(2));
        else if (col.field === "Cost")
          grandTotalRow[col.field] = grandTotalCost.toFixed(2);
        else if (col.field === "Index")
          grandTotalRow[col.field] = "Grand Total";
        else grandTotalRow[col.field] = "";
      });
      worksheet.addRow(grandTotalRow).font = { bold: true, size: 11 };

      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, fileName);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
    }
  };

  const getGroupedList = () => {
    if (
      !filteredMachineryReportList ||
      typeof filteredMachineryReportList !== "object"
    )
      return [];

    const entries = Object.entries(filteredMachineryReportList);

    if (filterData.GroupBy === "None") {
      return entries
        .sort(([nameA], [nameB]) => {
          const equipA = equipmentList.find((e) => e.label === nameA);
          const equipB = equipmentList.find((e) => e.label === nameB);
          const seqA = equipA ? parseInt(equipA.SerialNo) || 9999 : 9999;
          const seqB = equipB ? parseInt(equipB.SerialNo) || 9999 : 9999;
          return seqA !== seqB ? seqA - seqB : nameA.localeCompare(nameB);
        })
        .map(([name, items], index) => {
          const equip = equipmentList.find((e) => e.label === name);
          return {
            GroupName: name,
            SerialNo: equip ? equip.SerialNo : "",
            details: items,
            Index: index + 1,
          };
        });
    } else {
      return entries
        .sort(([nameA], [nameB]) => nameA.localeCompare(nameB))
        .map(([name, items], index) => {
          return {
            GroupName: name,
            details: items,
            Index: index + 1,
          };
        });
    }
  };

  const getDateRange = () => {
    const { FilterDate, FromDate } = filterData;
    let startDate, endDate;

    if (FilterDate) {
      const today = moment().startOf("day");

      switch (FilterDate) {
        case "Today":
          startDate = today.clone();
          endDate = today.clone().endOf("day");
          break;
        case "7 Days":
          startDate = today
            .clone()
            .subtract(6, "days")
            .startOf("day");
          endDate = today.clone().endOf("day");
          break;
        case "30 Days":
          startDate = today
            .clone()
            .subtract(29, "days")
            .startOf("day");
          endDate = today.clone().endOf("day");
          break;
        default:
          startDate = today.clone();
          endDate = today.clone().endOf("day");
      }
    } else {
      startDate = FromDate[0]
        ? moment(FromDate[0]).startOf("day")
        : moment().startOf("day");
      endDate = FromDate[1]
        ? moment(FromDate[1]).endOf("day")
        : moment().endOf("day");
    }

    const totalDays = endDate.diff(startDate, "days") + 1;
    const dateRangeText = `From ${startDate.format(
      "DD-MMM-YYYY",
    )} to ${endDate.format("DD-MMM-YYYY")}`;

    return { startDate, endDate, totalDays, dateRangeText };
  };

  const summaryReport = () => {
    if (
      !filteredMachineryReportList ||
      !Object.keys(filteredMachineryReportList).length
    )
      return;

    const { totalDays, dateRangeText } = getDateRange();
    const { GroupBy } = filterData;

    let summaryRows = [];
    let groupHeader = "Machine Name";
    let groupField = "Machine";

    if (GroupBy === "Items") {
      groupHeader = "Item Name";
      groupField = "Item";
    } else if (GroupBy === "Godown") {
      groupHeader = "Godown Name";
      groupField = "Godown";
    }

    const entries = Object.entries(filteredMachineryReportList);

    if (GroupBy === "None") {
      entries.sort(([nameA], [nameB]) => {
        const equipA = equipmentList.find((e) => e.label === nameA);
        const equipB = equipmentList.find((e) => e.label === nameB);
        const seqA = equipA ? parseInt(equipA.SerialNo) || 9999 : 9999;
        const seqB = equipB ? parseInt(equipB.SerialNo) || 9999 : 9999;
        return seqA !== seqB ? seqA - seqB : nameA.localeCompare(nameB);
      });
    } else {
      entries.sort(([nameA], [nameB]) => nameA.localeCompare(nameB));
    }

    entries.forEach(([name, items]) => {
      let totalCost = 0;
      (items || []).forEach((entry) => {
        const cost = parseFloat(entry.Cost) || 0;
        totalCost += cost;
      });

      summaryRows.push({
        [groupField]: name,
        TotalCost: totalCost.toFixed(2),
        Cost: (totalCost / totalDays).toFixed(2),
      });
    });

    const summary = {
      Details: {
        DateRange: dateRangeText,
        TotalDays: totalDays,
      },
      Data: summaryRows,
      Columns: [
        {
          id: 1,
          field: "Index",
          header: "Sr. No",
          body: actionBodyTemplateSrNo,
        },
        { id: 2, field: groupField, header: groupHeader },
        { id: 3, field: "TotalCost", header: "Total Cost" },
        { id: 4, field: "Cost", header: "Cost Per Day" },
      ],
    };

    setSummaryData(summary);
    setShowSummary(true);
  };

  const renderDetailsTable = (rowData) => {
    return (
      <DataTable
        value={rowData.details}
        className="nested-table"
        responsiveLayout="scroll"
        emptyMessage="No records found"
      >
        <Column field="Date" header="Date" />
        <Column field="OutwardNumber" header="Outward Number" />
        {filterData.GroupBy !== "Items" && (
          <Column field="Item" header="Item" />
        )}
        {filterData.GroupBy !== "None" && (
          <Column field="Machine" header="Machine" />
        )}
        <Column field="Quantity" header="Quantity" />
        <Column field="Unit" header="Unit" />
        <Column field="Cost" header="Cost" />
        {filterData.GroupBy !== "Godown" && (
          <Column field="Subwarehouse" header="Subwarehouse" />
        )}
      </DataTable>
    );
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      {loading === true ? (
        <div className="loading">
          <SimpleBackdrop />
        </div>
      ) : null}
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-upload"></i>
          <h2>Machinery Report</h2>
        </div>

        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              className="searchbar"
              type="search"
              onChange={(e) => handleGlobalFilter(e)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!globalFilter ? <i className="icon-search"></i> : null}
          </div>

          <div
            className="e-add-btn"
            title="Export Excel"
            onClick={(e) => {
              excelMenuOp.current.toggle(e);
            }}
          >
            <i className="pi pi-file-excel"></i>
          </div>

          <OverlayPanel
            ref={excelMenuOp}
            style={{ width: "260px" }}
            className="export-menu-overlay"
          >
            <div
              className="p-menu p-component"
              style={{ border: "none", padding: "0" }}
            >
              <ul
                className="p-menu-list"
                role="menu"
                style={{ margin: 0, padding: 0, listStyle: "none" }}
              >
                <li className="p-menuitem" role="none" style={{ margin: 0 }}>
                  <span
                    role="menuitem"
                    className="p-menuitem-link"
                    onClick={() => {
                      excelMenuOp.current.hide();
                      exportToExcel("Machine");
                    }}
                    style={{
                      cursor: "pointer",
                      padding: "8px 12px",
                      display: "flex",
                      alignItems: "center",
                      color: "#333",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      transition: "background-color 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f4f4f4")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <i
                      className="pi pi-file-excel p-mr-2"
                      style={{ color: "#28a745" }}
                    ></i>
                    Machine Wise Excel
                  </span>
                </li>
                <li className="p-menuitem" role="none" style={{ margin: 0 }}>
                  <span
                    role="menuitem"
                    className="p-menuitem-link"
                    onClick={() => {
                      excelMenuOp.current.hide();
                      exportToExcel("MachineSummary");
                    }}
                    style={{
                      cursor: "pointer",
                      padding: "8px 12px",
                      display: "flex",
                      alignItems: "center",
                      color: "#333",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      transition: "background-color 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f4f4f4")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <i
                      className="pi pi-file-excel p-mr-2"
                      style={{ color: "#28a745" }}
                    ></i>
                    Machine Wise Summary Excel
                  </span>
                </li>
                <li className="p-menuitem" role="none" style={{ margin: 0 }}>
                  <span
                    role="menuitem"
                    className="p-menuitem-link"
                    onClick={() => {
                      excelMenuOp.current.hide();
                      exportToExcel("Item");
                    }}
                    style={{
                      cursor: "pointer",
                      padding: "8px 12px",
                      display: "flex",
                      alignItems: "center",
                      color: "#333",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      transition: "background-color 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f4f4f4")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <i
                      className="pi pi-file-excel p-mr-2"
                      style={{ color: "#28a745" }}
                    ></i>
                    Item Wise Excel
                  </span>
                </li>
                <li className="p-menuitem" role="none" style={{ margin: 0 }}>
                  <span
                    role="menuitem"
                    className="p-menuitem-link"
                    onClick={() => {
                      excelMenuOp.current.hide();
                      exportToExcel("ItemSummary");
                    }}
                    style={{
                      cursor: "pointer",
                      padding: "8px 12px",
                      display: "flex",
                      alignItems: "center",
                      color: "#333",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      transition: "background-color 0.2s",
                    }}
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.backgroundColor = "#f4f4f4")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.backgroundColor = "transparent")
                    }
                  >
                    <i
                      className="pi pi-file-excel p-mr-2"
                      style={{ color: "#28a745" }}
                    ></i>
                    Item Wise Summary Excel
                  </span>
                </li>
              </ul>
            </div>
          </OverlayPanel>

          <Button
            onClick={() => summaryReport()}
            // icon="icon-filter"
            className="p-ml-2"
          >
            Summary
          </Button>

          <div className="p-position-relative">
            <Button
              onClick={(e) => {
                op.current.toggle(e);
              }}
              icon="icon-filter"
              rounded
              className="wb-search-btn p-ml-2"
            />

            {/* <button onClick={generatePDF}>Export PDF</button> */}
            <div className="header-bar">
              <div className="right-nav-buttons p-d-flex">
                <div>
                  <div className="noti-dropdown-outer">
                    <OverlayPanel
                      ref={op}
                      style={{ width: 500 }}
                      className="machinery-filter-overlay"
                    >
                      <div className="filter-header">
                        <h3>Filter Options</h3>
                      </div>
                      <div className="filter-content">
                        <div className="p-grid">
                          <div className="p-col-12">
                            <div className="custom-inputs">
                              <label>Select Date Range</label>
                              <div className="">
                                <SelectButton
                                  value={filterData.FilterDate}
                                  onChange={(e) => {
                                    setFilterData((prevState) => ({
                                      ...prevState,
                                      FilterDate: e.value,
                                      FromDate: null,
                                    }));
                                  }}
                                  options={filterOptions}
                                />
                                <div className="custom-date-picker-wrapper p-mt-3 p-position-relative">
                                  <div
                                    className="p-inputgroup"
                                    onClick={() => {
                                      if (!showCalendar) {
                                        setTempFromDate(
                                          filterData.FromDate || [
                                            new Date(),
                                            new Date(),
                                          ],
                                        );
                                      }
                                      setShowCalendar(!showCalendar);
                                    }}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <InputText
                                      readOnly
                                      style={{
                                        cursor: "pointer",
                                        height: "40px",
                                        backgroundColor: "#fff",
                                      }}
                                      placeholder="Start Date - End Date"
                                      value={
                                        Array.isArray(filterData.FromDate) &&
                                          filterData.FromDate[0]
                                          ? `${moment(
                                            filterData.FromDate[0],
                                          ).format("DD/MM/YYYY")} - ${filterData.FromDate[1]
                                            ? moment(
                                              filterData.FromDate[1],
                                            ).format("DD/MM/YYYY")
                                            : ""
                                          }`
                                          : filterData.FromDate &&
                                            !Array.isArray(filterData.FromDate)
                                            ? moment(filterData.FromDate).format(
                                              "DD/MM/YYYY",
                                            )
                                            : ""
                                      }
                                    />
                                    <Button
                                      type="button"
                                      icon="pi pi-calendar"
                                      style={{ height: "40px" }}
                                    />
                                  </div>
                                  {showCalendar && (
                                    <div
                                      className="p-p-2 p-mt-1"
                                      style={{
                                        position: "absolute",
                                        zIndex: 1000,
                                        top: "100%",
                                        right: 0,
                                        border: "1px solid #ced4da",
                                        borderRadius: "4px",
                                        backgroundColor: "#ffffff",
                                        width: "325px",
                                        boxShadow:
                                          "0 4px 6px rgba(0, 0, 0, 0.1)",
                                      }}
                                    >
                                      <Calendar
                                        inline
                                        selectionMode="range"
                                        value={tempFromDate}
                                        onChange={(e) =>
                                          setTempFromDate(e.value)
                                        }
                                      />
                                      <div
                                        className="p-d-flex p-jc-end p-mt-2 p-pt-2"
                                        style={{
                                          borderTop: "1px solid #ced4da",
                                        }}
                                      >
                                        <Button
                                          type="button"
                                          label="Cancel"
                                          className="p-button-text p-button-secondary p-mr-2"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setTempFromDate(
                                              filterData.FromDate,
                                            );
                                            setTimeout(
                                              () => setShowCalendar(false),
                                              10,
                                            );
                                          }}
                                        />
                                        <Button
                                          type="button"
                                          label="OK"
                                          className="primary-btn"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            e.stopPropagation();
                                            setFilterData((prevState) => ({
                                              ...prevState,
                                              FilterDate: null,
                                              FromDate: tempFromDate,
                                            }));
                                            setTimeout(
                                              () => setShowCalendar(false),
                                              10,
                                            );
                                          }}
                                        />
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="p-col-12 p-md-6">
                            <div className="custom-inputs">
                              <label>Machines</label>
                              <MultiSelect
                                value={filterData.Machine}
                                options={equipmentList}
                                optionLabel="label"
                                display="chip"
                                fixedPlaceholder={true}
                                placeholder="Select Machines"
                                onChange={(e) => {
                                  setFilterData((prevState) => ({
                                    ...prevState,
                                    Machine: e?.value,
                                  }));
                                  e.stopPropagation();
                                }}
                                filter
                              />
                            </div>
                          </div>

                          <div className="p-col-12 p-md-6">
                            <div className="custom-inputs">
                              <label>Items</label>
                              <MultiSelect
                                value={filterData.Item}
                                options={itemList}
                                optionLabel="label"
                                display="chip"
                                fixedPlaceholder={true}
                                placeholder="Select Items"
                                onChange={(e) => {
                                  setFilterData((prevState) => ({
                                    ...prevState,
                                    Item: e?.value,
                                  }));
                                  e.stopPropagation();
                                }}
                                filter
                              />
                            </div>
                          </div>

                          <div className="p-col-12 p-md-6">
                            <div className="custom-inputs">
                              <label>Godown</label>
                              <MultiSelect
                                value={filterData.Subwarehouse}
                                options={subwarehouseList}
                                optionLabel="label"
                                display="chip"
                                fixedPlaceholder={true}
                                placeholder="Select Godown"
                                onChange={(e) => {
                                  setFilterData((prevState) => ({
                                    ...prevState,
                                    Subwarehouse: e?.value,
                                  }));
                                  e.stopPropagation();
                                }}
                                filter
                              />
                            </div>
                          </div>

                          <div className="p-col-12 p-md-6">
                            <div className="custom-inputs">
                              <label>Group By</label>
                              <Dropdown
                                inputId="groupBy"
                                placeholder="Group By"
                                value={filterData.GroupBy}
                                onChange={(e) => {
                                  setFilterData((prevState) => ({
                                    ...prevState,
                                    GroupBy: e?.value,
                                  }));
                                  e.stopPropagation();
                                }}
                                options={groupByList}
                                optionLabel="label"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="filter-footer">
                        <Button
                          className="primary-btn1"
                          onClick={(e) => {
                            handleReset(e);
                          }}
                        >
                          Reset
                        </Button>
                        <Button
                          className="primary-btn"
                          onClick={() => GetMachineryReport(userId)}
                        >
                          Apply Filters
                        </Button>
                      </div>
                    </OverlayPanel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="export-custom-large-wb-table">
        <DataTable
          className="main-table table-td"
          value={getGroupedList()}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={renderDetailsTable}
          dataKey="GroupName"
          responsiveLayout="scroll"
          emptyMessage="No records found"
        >
          <Column expander style={{ width: "3em" }} />
          <Column field="Index" header="Sr.No" style={{ width: "6%" }} />
          <Column
            field="GroupName"
            header={
              filterData.GroupBy === "Items"
                ? "Item Name"
                : filterData.GroupBy === "Godown"
                  ? "Godown Name"
                  : "Machine Name"
            }
            style={{ width: "25%" }}
          />
        </DataTable>
      </div>

      <Dialog
        open={showSummary}
        onClose={() => handleClose("Summary")}
        aria-labelledby="cha-form-dialog-title"
        className="e-form-dialog-title export-custom-large-wb-table"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Summary</div>
          <div className="dialog-close" onClick={(e) => handleClose("Summary")}>
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="summary-custom-large-wb-table">
          <div>Date: {summaryData.Details?.DateRange}</div>
          <div>Total Days: {summaryData.Details?.TotalDays}</div>
          <DataTableWithoutPagination
            {...props}
            columns={summaryData.Columns}
            data={summaryData.Data}
          />
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={(e) => handleClose("Summary")}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MachineryConsumptionReport;
